module.exports = __webpack_public_path__ + "static/integrately-fe8531ab49970c1f64de9379d89ff790.svg";